import classNames from "classnames"
import styles from "./styles.module.scss"
import { ReactNode } from "react"
import CheckmarkOutline from "~icons/eva/checkmark-outline"

type CheckboxProps = {
  label?: string
  children?: ReactNode
  isChecked: boolean
  onChange: (checked: boolean) => void
}

export const Checkbox = ({ label, children, isChecked, onChange }: CheckboxProps) => {
  return (
    <label className={styles.container}>
      <input
        type="checkbox"
        className={styles.hiddenCheckbox}
        checked={isChecked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <div className={classNames(styles.checkbox, isChecked && styles.checked)}>
        {isChecked ? <CheckmarkOutline /> : null}
      </div>
      {label && <span className={styles.label}>{label}</span>}
      {children ? children : null}
    </label>
  )
}
